<template>
    <!-- 前台页面更新 -->
    <!-- 头部操作 -->
  <operateButton @btn-handle="btnHandle" @btn-in-table="btnInTable"
        :style="btnLeftList.length > 0 ? '' : 'display:block;'" @btn-on-left="btnOnList" />
  <el-button-group v-if="false">>
        <el-button type="primary" size="large" @click="batchPublish">
            <el-icon><Finished /></el-icon>&nbsp;
            批量发布
        </el-button>
    </el-button-group>
    <!-- 表格组件 -->
    <TableList
        :table-data="tableData"
        :header-data="headerData"
        :table-height="
        btnLeftList.length > 0 ? tableMaxHeight : tableMaxHeight + 40
      "
        :loading="loading"
        :loading-text="'发布中'"
        :empty-text="'暂无数据'"
        @handleSelection="handleSelectionChange"
    >
         <!-- 列表按钮操作动态 -->
      <template #inTableCustom="scope">
        <div class="optionDiv" style="white-space: nowrap; display: inline-block; float: left">
          <el-button-group style="display: flex" v-if="buttonList && buttonList.length > 1">
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </el-button-group>
          <div v-else>
            <el-tooltip :content="item.tip ? item.tip : item.name" v-for="(item, index) in buttonList" placement="top"
              :disabled="!item.tip">
              <el-button size="default" :type="item.className" @click="doEvent(item.eventName, scope.scope)"
                :plain="!item.isPlain" :icon="item.icon">{{ item.name }}</el-button>
            </el-tooltip>
          </div>
        </div>
      </template>
        <template #operationCustom="scope">
            <el-button type="primary" size="default" plain @click="releaseFnc(scope.scope)">发布</el-button>
        </template>
    </TableList>
</template>

<script>
import TableList from "@/components/TableHeaderCom/index.vue"; // 路径按实际调整
import { reactive, toRefs, h, onMounted, ref ,nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
    PublishHomeMobile, PublishPtzsbHtmlMobile, PublishZkzsbHtmlMobile,
    PublishCkzsbHtmlMobile, PublishWlycjyHtmlMobile, PublishHome, CreatePtzsbCategoryHtml,
    CreateZkzsbCategoryHtml, CreateCkzsbCategoryHtml, CreateWlycjyCategoryHtml, PublishHtml, GetPublishCategory
} from "network/pageUpdate.js";
export default {
    name: "PageUpdate",
    components: { TableList },
    props: {
        tableMaxHeight: Number,
    },
    setup() {
        const data = reactive({
            tableData: [
                { name: '【手机端】专升本首页', id: 1 },
                { name: '【手机端】普通专升本', id: 2 },
                { name: '【手机端】自考专升本', id: 3 },
                { name: '【手机端】成考专升本', id: 4 },
                { name: '【手机端】开放教育', id: 5 },
                { name: '【电脑端】专升本首页', id: 6 },
                { name: '【电脑端】普通专升本', id: 7 },
                { name: '【电脑端】自考专升本', id: 8 },
                { name: '【电脑端】成考专升本', id: 9 },
                { name: '【电脑端】开放教育', id: 10 }
            ],
            headerData: [
                {
                    label: "勾选框",
                    type: "selection",
                    width: "55",
                    fixed: "left",
                },
                {
                    label: "页面名称",
                    prop: "name",
                    align: "left",
                    fixed: "left",
                },
            ],
            loading: false,
            multipleSelection: [],
        });

        onMounted(() => {
            getPublishCategory();
        });

        const releaseFnc = (e) => {
            ElMessageBox({
                title: "发布",
                message: h("p", null, [
                    h("span", null, "是否发布"),
                    h("b", { style: "color: #fd5252;font-size:16px;" }, `${data.multipleSelection[0].name}`),
                    h("span", null, "？ "),
                ]),
                showCancelButton: true,
                cancelButtonText: "取消",
                confirmButtonText: "确认",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = "确认中",
                        done();
                        postHtml(data.multipleSelection[0].id)
                    } else {
                        done();
                    }
                },
            }).catch(() => {
                ElMessage("取消发布");
            });
        };

        const postHtml = async (id) => {
            data.loading = true
            let result = {};
            if(id == 1 ){
                result = await PublishHomeMobile();
            }else if(id ==2){
                result = await PublishPtzsbHtmlMobile();
            } else if (id == 3) {
                result = await PublishZkzsbHtmlMobile();
            } else if (id == 4) {
                result = await PublishCkzsbHtmlMobile();
            } else if (id == 5) {
                result = await PublishWlycjyHtmlMobile();
            } else if (id == 6) {
                result = await PublishHome();
            } else if (id == 7) {
                result = await CreatePtzsbCategoryHtml();
            } else if (id == 8) {
                result = await CreateZkzsbCategoryHtml();
            } else if (id == 9) {
                result = await CreateCkzsbCategoryHtml();
            } else if (id == 10) {
                result = await CreateWlycjyCategoryHtml();
            }
            if (result.code == 1) {
                ElMessageBox.alert(result.message,"发布", {
                    confirmButtonText: "确定",
                });
            } else {
                ElMessageBox.alert(result.message, "发布", {
                    confirmButtonText: "确定",
                });
            }
            data.loading = false
        };

        const handleSelectionChange = (val) => {
            data.multipleSelection = val;
        };

        const getPublishCategory = async () => {
            let res = await GetPublishCategory()
        };

        const batchPublish = () => {
            if (data.multipleSelection && data.multipleSelection.length == 0) {
                ElMessage.error("请选择一个页面!");
                return;
            }
            let ids = []
            data.multipleSelection.forEach((ele)=>{
                ids.push(ele.id)
            })
            ElMessageBox({
                title: "发布",
                message: h("p", null, [
                    h("span", null, "确定将选中的【"),
                    h("b", { style: "color: #fd5252;font-size:16px" }, `${data.multipleSelection.length}`),
                    h("span", null, "】个页面发布吗？ "),
                ]),
                showCancelButton: true,
                cancelButtonText: "取消",
                confirmButtonText: "确认",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = "发布中",
                        PublishHtml(ids)
                        .then((result) => {
                            done();
                            let str = ''
                            result?.result?.forEach((item,index)=>{
                                str = str + ` ${index + 1}.` + item
                            })
                            str = str?str:result.message?result.message:'发布成功'
                            ElMessageBox.alert(str, "发布", {
                                confirmButtonText: "确认",
                            });
                        })
                        .catch((err) => {
                            done();
                            let str = ''
                            err?.result?.forEach((item,index)=>{
                                str = str + `${index + 1}.` + item
                            })
                            str = str?str:err.message?err.message:'发布失败'
                            ElMessageBox.alert(str, "发布", {
                                confirmButtonText: "确认",
                            });
                        })
                    } else {
                        done();
                    }
                },
            }).catch(() => {
                ElMessage("取消发布");
            });
        };
const doEvent = function (btn, row) {
  try {
    data.multipleSelection = [];
    data.multipleSelection.push(row);
    eval(btn.split("(")[0] + `()`);
  }
  catch (err) {
    console.log(err);
    
    ElMessageBox.alert("err");
  }
}
    const btnHandle = (val) => {
      try {
        eval(val);
      } catch (error) {
        ElMessage.error("按钮事件不存在");
      }
    };
    const btnLeftList = ref([]);
    const buttonList = ref([]);
    const btnOnList = (val) => {
      btnLeftList.value = val ? val : [];
    }
    const btnInTable = async (val) => {
      if (val?.length > 0) {
        // 先设置按钮数据并插入列定义
        buttonList.value = val;
        data.headerData.splice(1, 0, {
          label: "操作",
          prop: "inTable",
          align: "center",
          fixed: "left",
          custom: true,
          isInTable: true,
        });
        // 等待 DOM 更新，确保表格单元格渲染完毕以便正确测量宽度
        await nextTick();
        await nextTick();
        // 获取操作按钮组的元素并测量宽度
        const opts = document.getElementsByClassName("optionDiv");
        let widthArr = [];
        Array.prototype.forEach.call(opts, function (item) {
          if (item.offsetWidth > 0) {
            widthArr.push(item.offsetWidth);
          }
        });
        if (widthArr.length > 0 && buttonList.value?.length > 0) {
          let index = 0;
          var obj = {};
          for (var i = 0; i < data.headerData.length; i++) {
            if (data.headerData[i].label == "操作") {
              index = i;
              obj = JSON.parse(JSON.stringify(data.headerData[i]));
              // 使用数字类型宽度（px由组件处理），并留出一定内边距
              obj.width = Math.max(...widthArr) + 24;
            }
          }
          data.headerData[index] = obj;
        }
      }
    };
        return {
            ...toRefs(data),
            releaseFnc,
            handleSelectionChange,
            batchPublish,
            getPublishCategory,
            btnInTable,
            btnLeftList,
            buttonList,
            btnOnList,
            btnHandle,
            doEvent,
        };
    },
};
</script>


